import React from 'react';
import { FieldTitle, InputHelperText, useLocaleState, useInput, sanitizeInputRestProps } from 'react-admin';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { deDE, frFR, itIT, nlNL, plPL } from '@mui/x-date-pickers/locales';
import clsx from 'clsx';
import moment from 'moment-timezone';

moment.tz.setDefault('UTC');

const LOCALES = {
    'de': deDE,
    'fr': frFR,
    'it': itIT,
    'nl': nlNL,
    'pl': plPL
};

const DateTimeInput = ({ formatInput, ...props }) => {
    const [locale] = useLocaleState();
    const {
        className,
        defaultValue,
        label,
        format,
        helperText,
        onBlur,
        onChange,
        parse,
        resource,
        source,
        validate,
        ...rest
    } = props;
    const {
        field,
        fieldState: { error, invalid, isTouched },
        formState: { isSubmitted },
        id,
        isRequired,
    } = useInput({
        defaultValue,
        format,
        parse,
        resource,
        source,
        validate,
        onBlur,
        onChange,
        ...rest
    });
    const localeText = locale && locale !== 'en' ? LOCALES[locale]?.components?.MuiLocalizationProvider?.defaultProps?.localeText : null;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} localeText={localeText}>
            <DateTimePicker
                id={id}
                {...field}
                value={field.value ? moment(field.value) : null}
                label={
                    label !== '' && label !== false ? (
                        <FieldTitle
                            label={label}
                            source={source}
                            resource={resource}
                            isRequired={isRequired}
                        />
                    ) : null
                }
                className={clsx('ra-input', `ra-input-${source}`, className)}
                error={(isTouched || isSubmitted) && invalid}
                slotProps={{
                    textField: {
                        size: 'small',
                        error: !!error,
                        helperText: (
                            <InputHelperText
                                touched={isTouched || isSubmitted}
                                error={error?.message}
                                helperText={helperText}
                            />
                        )
                    }
                }}
                {...sanitizeInputRestProps(rest)}
                format={formatInput}
                timezone="UTC"
            />
        </LocalizationProvider>
    );
};

DateTimeInput.defaultProps = {
    ampm: false,
    formatInput: 'DD/MM/YYYY HH:mm'
};

export default DateTimeInput;